import { t } from 'i18next';
import { COMMON_TRANSLATE_KEYS } from '../constants/translate-keys';
import dayjs from 'dayjs';

export const DATE_FORMATS = {
  WEEK_FIRST: 'dddd, DD MMMM YYYY',
  WEEK_FIRST_WITH_YEAR: 'dddd, DD MMMM YYYY',
  WEEK_FIRST_WITH_YEAR_SHORT: 'dddd, DD.MM.YYYY',
  HOURS_MINUES: 'HH:mm',
  DATE_DOTS: 'DD.MM.YYYY',
  WEEKDAY_ONLY: 'dddd',
};

export const getDateForCalendar = (date: string) =>
  new Date(date.replace('Z', ''));

export const getRecurringDays = (days: number[]) => {
  // Sort ascending, but zero is at the end
  const sortedDays = days.sort((a, b) => {
    if (a === 0 && b !== 0) return 1;
    if (a !== 0 && b === 0) return -1;
    return a - b;  
  });

  return sortedDays.map((day) => {
    switch (day) {
      case 0:
        return t(COMMON_TRANSLATE_KEYS.SUNDAY_NORMAL);
      case 1:
        return t(COMMON_TRANSLATE_KEYS.MONDAY_NORMAL);
      case 2:
        return t(COMMON_TRANSLATE_KEYS.TUESDAY_NORMAL);
      case 3:
        return t(COMMON_TRANSLATE_KEYS.WEDNESDAY_NORMAL);
      case 4:
        return t(COMMON_TRANSLATE_KEYS.THURSDAY_NORMAL);
      case 5:
        return t(COMMON_TRANSLATE_KEYS.FRIDAY_NORMAL);
      case 6:
        return t(COMMON_TRANSLATE_KEYS.SATURDAY_NORMAL);
      default:
        return '';
    }
  });
};

export const getTimeAgoText = (
  date: Date,
  toLowerCase = false,
  dateToCompare = new Date()
) => {
  const minuteDiff = dayjs(dateToCompare).diff(date, 'minute', true);
  const hourDiff = dayjs(dateToCompare).diff(date, 'hour', true);
  const dayDiff = dayjs(dateToCompare).diff(date, 'day', true);
  const weekDiff = dayjs(dateToCompare).diff(date, 'week', true);
  const monthDiff = dayjs(dateToCompare).diff(date, 'month', true);
  const yearDiff = dayjs(dateToCompare).diff(date, 'year', true);

  let translateKey = '';

  if (yearDiff > 1) {
    translateKey = t(COMMON_TRANSLATE_KEYS.TIME_AGO_YEARS, {
      count: Math.floor(yearDiff),
    });
  } else if (monthDiff > 1) {
    translateKey = t(COMMON_TRANSLATE_KEYS.TIME_AGO_MONTHS, {
      count: Math.floor(monthDiff),
    });
  } else if (weekDiff > 1) {
    translateKey = t(COMMON_TRANSLATE_KEYS.TIME_AGO_WEEKS, {
      count: Math.floor(weekDiff),
    });
  } else if (dayDiff > 1) {
    translateKey = t(COMMON_TRANSLATE_KEYS.TIME_AGO_DAYS, {
      count: Math.floor(dayDiff),
    });
  } else if (hourDiff > 1) {
    translateKey = t(COMMON_TRANSLATE_KEYS.TIME_AGO_HOURS, {
      count: Math.floor(hourDiff),
    });
  } else if (minuteDiff > 1) {
    translateKey = t(COMMON_TRANSLATE_KEYS.TIME_AGO_MINUTES, {
      count: Math.floor(minuteDiff),
    });
  } else {
    translateKey = t(COMMON_TRANSLATE_KEYS.TIME_AGO_SECONDS);
  }

  if (toLowerCase) {
    return translateKey.toLowerCase();
  }

  return translateKey;
};

export const getHoursBetweenDates = (
  startDate: Date,
  endDate: Date,
  startHour = 9,
  endHour = 21,
  includePassed = false,
) => {
  let hours = [];
  let currentDate = dayjs(startDate);
  // let currentHour = startHour;
  
  // const now = dayjs().add(1, 'hour');
  
  // if (!includePassed) {
  //   if (dayjs(startDate).isBefore(now) && dayjs(endDate).isBefore(now)) {
  //     return [];
  //   }
    
  //   if (currentDate.isBefore(now)) {
  //     currentDate = dayjs(now);
  //     currentHour = now.hour();
  //   }
  // }

  while (currentDate.isBefore(dayjs(endDate)) || currentDate.isSame(dayjs(endDate, 'day'))) {
    for (let hour = startHour; hour <= endHour; hour++) {
      hours.push(currentDate.hour(hour).minute(0).toDate());
    }
    currentDate = currentDate.add(1, 'day'); // Move to the next day
    // currentHour = startHour;
  }

  return hours;
};
